import { render, staticRenderFns } from "./candidate-register.vue?vue&type=template&id=768be876&scoped=true&"
import script from "./candidate-register.vue?vue&type=script&lang=js&"
export * from "./candidate-register.vue?vue&type=script&lang=js&"
import style0 from "./candidate-register.vue?vue&type=style&index=0&id=768be876&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768be876",
  null
  
)

export default component.exports